import React from 'react'
import BrandsRulePage from './BrandsRulePage'

const BrandsRulePageContainer = () => {

    return (
        <div className='BrandsRulePageContainer'>
            <BrandsRulePage />
        </div>
    )
}

export default BrandsRulePageContainer